import React from 'react';
import classnames from 'classnames';

import { AttachmentImage, AttachmentsDisplayModal } from '@components/Attachment';

import { getFileType, isMobile } from '@utils/AppUtil';

import './style.scss';

export interface IPrivateCSDPAttachmentsTileProps {
  attachments: ICSAttachmentResponse[];
  trackViewAttachment?: (fileName: string) => void;
}

export interface IPrivateCSDPAttachmentsTileState {
  isAttachmentDisplayModalOpen: boolean;
  attachmentIndex: number;
}

export class PrivateCSDPAttachmentsTile extends React.Component<
  IPrivateCSDPAttachmentsTileProps,
  IPrivateCSDPAttachmentsTileState
> {
  constructor(props: IPrivateCSDPAttachmentsTileProps) {
    super(props);

    this.state = this.getEmptyState();
  }

  getEmptyState = (): IPrivateCSDPAttachmentsTileState => ({
    isAttachmentDisplayModalOpen: false,
    attachmentIndex: 0,
  });

  toggleAttachmentsEditModal =
    (attachmentIndex: number = null) =>
    (e?: React.SyntheticEvent<any>) => {
      if (attachmentIndex !== null) {
        this.props.trackViewAttachment?.(this.props.attachments[attachmentIndex].fileName);
      }

      this.setState((prevState) => ({
        isAttachmentDisplayModalOpen: !prevState.isAttachmentDisplayModalOpen,
        attachmentIndex,
      }));
    };

  getThumb = (file: ICSAttachmentResponse, index: number) => {
    const attachmentLabel = file.fileName ? `Open attachment ${file.fileName}` : `Open attachment ${index + 1}`;
    const openAttachment = this.toggleAttachmentsEditModal(index);
    const fileTypeToThumb = {
      image: (
        <button
          type="button"
          className={classnames('attachments-tile__saved-thumb')}
          onClick={openAttachment}
          aria-label={attachmentLabel}
          aria-haspopup="dialog"
        >
          <AttachmentImage src={file.fileURL} alt={file.fileName || 'Attachment thumbnail'} />
        </button>
      ),
      others: (
        <button
          type="button"
          className={classnames('attachments-tile__saved-thumb', 'attachments-tile__saved-thumb--others')}
          onClick={openAttachment}
          aria-label={attachmentLabel}
          aria-haspopup="dialog"
        ></button>
      ),
    };

    return fileTypeToThumb[getFileType(file)];
  };

  renderContent = () => (
    <div className={classnames('attachments-tile__attachments', 'private-csdp-attachment')}>
      {this.props.attachments &&
        this.props.attachments.map((file, index) => (
          <div
            key={index}
            className={classnames('attachments-tile__photo-container', 'private-csdp-attachment__photo-container')}
          >
            {this.getThumb(file, index)}
          </div>
        ))}
    </div>
  );

  renderAttachmentsEditModal = () => {
    const { attachments } = this.props;

    return (
      <AttachmentsDisplayModal
        title="Attachments"
        show={this.state.isAttachmentDisplayModalOpen}
        onClose={this.toggleAttachmentsEditModal()}
        attachments={attachments}
        openOnIndex={this.state.attachmentIndex}
        className={classnames('compact', {
          'compact-mobile': isMobile(),
        })}
        displayAttachmentDetails={!isMobile()}
      />
    );
  };

  render() {
    return (
      <div>
        {this.renderContent()}
        {this.renderAttachmentsEditModal()}
      </div>
    );
  }
}

export default PrivateCSDPAttachmentsTile;
